module.exports = __webpack_public_path__ + "img/p14.adac0a39.jpg";